var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.companyType",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsLegalAndBilling.company_type"
            ),
            error: _vm.getErrorKey("legal_france.rcs_immatriculation")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "company-type",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.companyType,
              callback: function($$v) {
                _vm.$set(_vm.legal, "companyType", $$v)
              },
              expression: "legal.companyType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.siret",
            label: _vm.$t.__("common.labels.siret"),
            error: _vm.getErrorKey("legal_france.siret")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "siret",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.siret,
              callback: function($$v) {
                _vm.$set(_vm.legal, "siret", $$v)
              },
              expression: "legal.siret"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.siren",
            label: _vm.$t.__("common.labels.siren"),
            error: _vm.getErrorKey("legal_france.siren")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "siren",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.siren,
              callback: function($$v) {
                _vm.$set(_vm.legal, "siren", $$v)
              },
              expression: "legal.siren"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.apeNafCode",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsLegalAndBilling.NAF_code"
            ),
            error: _vm.getErrorKey("legal_france.ape_naf_code")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "ape-naf",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.apeNafCode,
              callback: function($$v) {
                _vm.$set(_vm.legal, "apeNafCode", $$v)
              },
              expression: "legal.apeNafCode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.capital",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsLegalAndBilling.initial_capital"
            ),
            error: _vm.getErrorKey("capital")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "capital",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.capital,
              callback: function($$v) {
                _vm.capital = $$v
              },
              expression: "capital"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.rcsImmatriculation",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsLegalAndBilling.RCS"
            ),
            error: _vm.getErrorKey("legal_france.rcs_immatriculation")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "rcs",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.rcsImmatriculation,
              callback: function($$v) {
                _vm.$set(_vm.legal, "rcsImmatriculation", $$v)
              },
              expression: "legal.rcsImmatriculation"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "legalFrance.vat",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsLegalAndBilling.VAT_number"
            ),
            error: _vm.getErrorKey("legal_france.vat")
          }
        },
        [
          _c("el-input", {
            attrs: {
              "data-bot": _vm.getDatabot(
                "vat",
                _vm.currentStore,
                "legal-billing"
              ),
              autocomplete: "off"
            },
            model: {
              value: _vm.legal.vat,
              callback: function($$v) {
                _vm.$set(_vm.legal, "vat", $$v)
              },
              expression: "legal.vat"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }